import { useMemo } from 'react';
import { mapIconNamesToComponents } from './icons/index.js';
import './Icon.scss';
import { jsx } from 'react/jsx-runtime';

/* External */
function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className;
  var IconToRender = useMemo(function () {
    return mapIconNamesToComponents[name] || null;
  }, [name]);
  return IconToRender && /*#__PURE__*/jsx(IconToRender, {
    className: "dtv-common-c-icon dtv-common-c-icon-".concat(name, " ").concat(className)
  });
}
Icon.defaultProps = {
  className: ''
};

export { Icon as default };
//# sourceMappingURL=Icon.js.map
